(function () {
    /**
     * Used for small init functions.
     */

    const smoothScrollAnchors = () => {
        const anchorLinks = document.querySelectorAll(
            '.smooth-scroll-anchors a'
        );

        if (!anchorLinks) {
            return;
        } else {
            function smoothScroll(target) {
                document.querySelector(target).scrollIntoView({
                    behavior: 'smooth',
                });
            }

            for (let link of anchorLinks) {
                link.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    smoothScroll(ev.target.hash);
                });
            }
        }
    };

    /**
     * Scroll to top
     */
    const scrollButton = document.querySelector('#footer-backtotop');
    if (scrollButton != undefined) {
        scrollButton.addEventListener('click', (event) => {
            event.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }

    /**
     * Toggle Search
     */
    // const toggleSearch = () => {
    //     const searchToggleLink = document.getElementById('search-toggle'),
    //           searchInput = document.querySelector('.search-form__input'),
    //           searchFormEl = document.querySelector('.search-form'),
    //           searchSubmit = document.querySelector('.search-form__submit');

    //     searchToggleLink.addEventListener( 'click', function( event ) {
    //         searchFormEl.classList.toggle('toggled');

    //         if ( searchFormEl.classList.contains('toggled') ) {
    //             searchInput.focus();
    //             searchInput.value = '';
    //         }
    //     } );
    // }

    document.addEventListener('DOMContentLoaded', () => {
        /**
         * Init lazyload - used for lazyloading images and iframes that have class "lazy".
         * Plugin is enqueued in functions.php (commented out)
         * more examples: https://github.com/verlok/vanilla-lazyload#-getting-started---html
         */
        //var lazyLoadInstance = new LazyLoad();

        //toggleSearch();

        smoothScrollAnchors();
        MicroModal.init();
    });
})();
